// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.theme-container {
  min-height: 300px !important;
}

.main-carousel .swiper-slide {
  text-align: center;
  padding-bottom: 66.25%;
  position: relative;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.04);
}
.main-carousel img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  max-width: 100%;
}
.main-carousel .control-icons {
  position: absolute;
  z-index: 2;
  top: 24px;
  right: 20px;
}
.main-carousel .control-icons button.mat-mdc-button {
  min-width: 36px;
  width: 36px;
  padding: 0;
  margin: 0 4px;
  background: rgba(255, 252, 252, 0.6);
  transition: 0.2s;
  color: rgba(0, 0, 0, 0.87);
}
.main-carousel .control-icons button.mat-mdc-button:disabled {
  color: rgba(0, 0, 0, 0.26);
}
.main-carousel .control-icons button.mat-mdc-button:hover:enabled {
  background: rgb(255, 252, 252);
}

.small-carousel .swiper-slide img {
  display: block;
  opacity: 0.3;
}
.small-carousel .swiper-slide.active-thumb img {
  border-width: 3px;
  border-style: solid;
  box-sizing: border-box;
  opacity: 1;
}
.small-carousel .swiper-slide .swiper-lazy-preloader {
  margin-top: 10px;
}

.widget {
  margin-bottom: 40px;
}
.widget .widget-title {
  margin: 0 -16px 16px;
  padding: 8px 16px;
  text-transform: uppercase;
  font-weight: 400;
}
.widget:first-child .widget-title {
  margin: -16px -16px 16px;
  padding: 8px 16px;
  text-transform: uppercase;
  font-weight: 400;
}

.c-opidHus {
  width: auto;
  padding: 0;
  margin: 0 4px;
  background: rgba(255, 252, 252, 0.8);
  transition: 0.2s;
  color: rgba(0, 0, 0, 0.87);
  position: absolute;
  z-index: 10;
  padding: 2px 5px;
  max-width: 70vw;
  /* Setur hámarksbreiddina í 70% af skjávíddinni */
  word-wrap: break-word;
  /* Tryggir að textinn fari í næstu línu þegar hámarksbreiddin er náð */
  white-space: normal;
  /* Leyfir textanum að brjótast í nýjar línur */
}

.c-distances-container {
  margin: 5px 0px 5px 0px !important;
}

.c-distances .c-pic {
  width: 50%;
  height: 70px;
  float: left;
  text-align: center;
}

.c-distances .c-pic img {
  height: 50px !important;
  float: right;
  margin-top: 10px !important;
  margin-right: 10px;
}

.c-distances .c-text {
  width: 50%;
  float: left;
}

.c-distances .c-text .c-head {
  margin-top: 10px !important;
  font-size: 16px;
  color: #253a85;
  font-weight: 400;
  margin-bottom: 0px !important;
}

.c-distances .c-text .c-text-dist {
  font-size: 15px;
  margin-bottom: 0px !important;
}

.box.c-distances {
  width: 33% !important;
}

#thrsix-big {
  position: absolute;
  top: 84px;
  right: 114px;
  z-index: 3;
  background: #253a85;
  color: white;
  padding: 7px 14px;
  font-size: 12px;
  font-weight: bold;
  opacity: 0.7;
  transition: 0.5s;
  height: 32px;
  width: 55px;
  border-right: 1px solid rgba(255, 255, 255, 0.5215686275);
}

#fjarlaegd-i-thonustu {
  margin-bottom: 0px !important;
  border-bottom: none !important;
  padding-bottom: 5px !important;
}

.no-spinner {
  -moz-appearance: textfield;
  /* Hide the spinner controls in Firefox */
}

/* Hide the spinner controls in Chrome, Safari, Edge, Opera */
.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.button-container {
  display: flex;
  justify-content: space-between;
}
.button-container .button {
  width: 48%;
  margin-bottom: 10px;
}
@media (max-width: 1000px) {
  .button-container {
    display: flow-root !important;
  }
  .button-container .button {
    width: 100% !important;
    margin-bottom: 10px !important;
  }
}

.details-fasteign {
  display: flex;
  flex-wrap: wrap;
}

.item-fasteign {
  text-align: left;
  flex: 0 0 100%;
  margin-bottom: 5px !important;
  padding-left: 18px !important;
}

.kaupsamningar-saga .item-fasteign {
  margin-bottom: 8px !important;
}

@media (min-width: 600px) {
  .item-fasteign {
    border-left: 1px solid #f0f0f0;
    flex: 0 0 50%;
    margin-bottom: 2px !important;
  }
  .item-fasteign-full {
    flex: 0 0 100% !important;
  }
  .kaupsamningar-saga .item-fasteign {
    margin-bottom: 5px !important;
  }
}
.fasteignasala-mynd {
  float: left;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
  max-height: 200px;
  width: 100%;
  object-fit: contain;
}

.swiper-img {
  max-height: 150px !important;
}

iframe {
  border: none !important;
  border-radius: 0% !important;
}

.grunnupplysingar {
  margin-top: 10px;
  border: 1px solid #f0f0f0;
  padding-top: 12px !important;
  padding-bottom: 10px !important;
}

.fetch-documents {
  border: 1px solid #f0f0f0;
  padding: 10px;
}

.map-container {
  position: relative;
}

.custom-info-box {
  position: fixed;
  background: white;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  min-width: 200px;
  max-width: 300px;
}

.info-box-content {
  font-size: 14px;
  color: #333;
}

.info-box-image {
  display: block;
  max-width: 100%;
  height: auto;
  max-height: 200px;
  /* Stilltu eftir hentugleika */
  object-fit: contain;
  margin: 0 auto 10px;
}

.info-box-button {
  display: block;
  width: 100%;
  background: #253a85;
  color: white;
  padding: 8px;
  text-align: center;
  border-radius: 5px;
  margin-top: 10px;
  cursor: pointer;
  border: none;
}

.info-box-close {
  display: block;
  width: 100%;
  background: #ccc;
  padding: 8px;
  text-align: center;
  border-radius: 5px;
  margin-top: 5px;
  cursor: pointer;
  border: none;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0;
  /* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
  -moz-appearance: textfield;
  /* Firefox */
}

.c-link {
  color: rgba(0, 0, 0, 0.87) !important;
}

@media (max-width: 1200px) {
  .box.c-distances {
    width: 50% !important;
  }
}
@media (max-width: 800px) {
  .box.c-distances {
    width: 100% !important;
  }
  .custom-info-box {
    position: absolute !important;
  }
}
.custom-info-box.hidden {
  display: none;
}

.ad-2-mobile {
  display: block;
  height: 195px;
}
@media (min-width: 500px) {
  .ad-2-mobile {
    height: 245px;
  }
}
@media (min-width: 600px) {
  .ad-2-mobile {
    height: 300px;
  }
}
@media (min-width: 700px) {
  .ad-2-mobile {
    height: 390px;
  }
}
@media (min-width: 800px) {
  .ad-2-mobile {
    height: 450px;
  }
}
@media (min-width: 960px) {
  .ad-2-mobile {
    display: none;
  }
}

.mblInject .primary-color {
  color: rgba(0, 0, 0, 0.87) !important;
}
.mblInject .primary-color p,
.mblInject .primary-color h1,
.mblInject .primary-color h2,
.mblInject .primary-color h3,
.mblInject .primary-color h4,
.mblInject .primary-color h5,
.mblInject .primary-color h6,
.mblInject .primary-color span,
.mblInject .primary-color li,
.mblInject .primary-color a,
.mblInject .primary-color label,
.mblInject .primary-color strong,
.mblInject .primary-color em,
.mblInject .primary-color small,
.mblInject .primary-color i,
.mblInject .primary-color i::before {
  color: rgba(0, 0, 0, 0.87) !important;
}

.color-mbl-green::before {
  color: #008800 !important;
}

.block-display {
  display: block !important;
}

::ng-deep .mat-mdc-form-field.mbl-input {
  --mdc-outlined-text-field-outline-color: #a0a0a0 !important;
}
::ng-deep .mat-mdc-form-field.mbl-input .mdc-notched-outline {
  border-color: #a0a0a0 !important;
}
::ng-deep .mat-mdc-form-field.mbl-input.mat-focused {
  --mdc-outlined-text-field-focus-outline-color: #008800 !important;
}
::ng-deep .mat-mdc-form-field.mbl-input.mat-focused .mdc-notched-outline {
  border-color: #008800 !important;
}
::ng-deep .mat-mdc-form-field.mbl-input mat-label {
  color: rgba(0, 0, 0, 0.87) !important;
}

.mdc-list-item__primary-text {
  color: rgba(0, 0, 0, 0.87) !important;
}

.custom-tooltip {
  padding: 8px !important;
}

/* Þegar elementið er í fullscreen þarf það að fylla skjáinn */
#leafletMap:fullscreen,
#leafletMap:-webkit-full-screen {
  width: 100%;
  height: 100%;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/components/pages/properties-sold/property-sold/property-sold.component.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,4BAAA;AAAF;;AAIE;EACE,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+BAAA;AADJ;AAIE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAFJ;AAKE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;AAHJ;AAKI;EACE,eAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,oCAAA;EACA,gBAAA;EACA,0BAAA;AAHN;AAKM;EACE,0BAAA;AAHR;AAMM;EACE,8BAAA;AAJR;;AAYI;EACE,cAAA;EACA,YAAA;AATN;AAaM;EACE,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,UAAA;AAXR;AAeI;EACE,gBAAA;AAbN;;AAkBA;EACE,mBAAA;AAfF;AAiBE;EACE,oBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;AAfJ;AAmBI;EACE,wBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;AAjBN;;AAsBA;EACE,WAAA;EACA,UAAA;EACA,aAAA;EACA,oCAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iDAAA;EACA,qBAAA;EACA,sEAAA;EACA,mBAAA;EACA,8CAAA;AAnBF;;AAsBA;EACE,kCAAA;AAnBF;;AAsBA;EACE,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,uBAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,UAAA;EACA,WAAA;AAnBF;;AAsBA;EACE,2BAAA;EACA,eAAA;EACA,cC5HY;ED6HZ,gBAAA;EACA,6BAAA;AAnBF;;AAsBA;EACE,eAAA;EACA,6BAAA;AAnBF;;AAsBA;EACE,qBAAA;AAnBF;;AAsBA;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,mBC/IY;EDgJZ,YAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,yDAAA;AAnBF;;AAsBA;EACE,6BAAA;EACA,8BAAA;EACA,8BAAA;AAnBF;;AAsBA;EACE,0BAAA;EACA,yCAAA;AAnBF;;AAsBA,6DAAA;AACA;;EAEE,wBAAA;EACA,SAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,8BAAA;AAnBF;AAqBE;EACE,UAAA;EACA,mBAAA;AAnBJ;AA8BE;EAjBF;IAkBI,6BAAA;EA3BF;EA6BE;IACE,sBAAA;IACA,8BAAA;EA3BJ;AACF;;AA+BA;EACE,aAAA;EACA,eAAA;AA5BF;;AA+BA;EACE,gBAAA;EACA,cAAA;EACA,6BAAA;EACA,6BAAA;AA5BF;;AA+BA;EACE,6BAAA;AA5BF;;AA+BA;EACE;IACE,8BAAA;IACA,aAAA;IACA,6BAAA;EA5BF;EA+BA;IACE,yBAAA;EA7BF;EAgCA;IACE,6BAAA;EA9BF;AACF;AAiCA;EACE,WAAA;EACA,8DAAA;EACA,iBAAA;EACA,WAAA;EAEA,mBAAA;AA/BF;;AAkCA;EACE,4BAAA;AA/BF;;AAsCA;EACE,uBAAA;EACA,4BAAA;AAnCF;;AAsCA;EACE,gBAAA;EACA,yBAAA;EACA,4BAAA;EACA,+BAAA;AAnCF;;AAsCA;EACE,yBAAA;EACA,aAAA;AAnCF;;AAsCA;EACE,kBAAA;AAnCF;;AAsCA;EACE,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,yCAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AAnCF;;AAsCA;EACE,eAAA;EACA,WAAA;AAnCF;;AAsCA;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAnCF;;AAsCA;EACE,cAAA;EACA,WAAA;EACA,mBC5SY;ED6SZ,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AAnCF;;AAsCA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;AAnCF;;AAsCA;;EAEE,8CAAA;EACA,wBAAA;EACA,SAAA;EACA,uEAAA;AAnCF;;AAsCA;EACE,0BAAA;EACA,YAAA;AAnCF;;AAsCA;EACE,qCAAA;AAnCF;;AAsCA;EACE;IACE,qBAAA;EAnCF;AACF;AAsCA;EACE;IACE,sBAAA;EApCF;EAuCA;IACE,6BAAA;EArCF;AACF;AAwCA;EACE,aAAA;AAtCF;;AAyCA;EACE,cAAA;EACA,aAAA;AAtCF;AAyCE;EALF;IAMI,aAAA;EAtCF;AACF;AAyCE;EAVF;IAWI,aAAA;EAtCF;AACF;AAyCE;EAfF;IAgBI,aAAA;EAtCF;AACF;AAyCE;EApBF;IAqBI,aAAA;EAtCF;AACF;AAyCE;EAzBF;IA0BI,aAAA;EAtCF;AACF;;AA2CA;EACE,qCAAA;AAxCF;AA0CE;;;;;;;;;;;;;;;;EAgBE,qCAAA;AAxCJ;;AA4CA;EACE,yBAAA;AAzCF;;AA4CA;EACE,yBAAA;AAzCF;;AA6CA;EACE,2DAAA;AA1CF;AA4CE;EACE,gCAAA;AA1CJ;AA6CE;EACE,iEAAA;AA3CJ;AA6CI;EACE,gCAAA;AA3CN;AA+CE;EACE,qCAAA;AA7CJ;;AAiDA;EACE,qCAAA;AA9CF;;AAiDA;EACE,uBAAA;AA9CF;;AAiDA,8DAAA;AACA;;EAEE,WAAA;EACA,YAAA;EACA,cAAA;AA9CF","sourcesContent":["@import \"../../../../../styles/variables.scss\";\r\n\r\n.theme-container {\r\n  min-height: 300px !important;\r\n}\r\n\r\n.main-carousel {\r\n  .swiper-slide {\r\n    text-align: center;\r\n    padding-bottom: 66.25%;\r\n    position: relative;\r\n    overflow: hidden;\r\n    background: rgba(0, 0, 0, 0.04);\r\n  }\r\n\r\n  img {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: auto;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .control-icons {\r\n    position: absolute;\r\n    z-index: 2;\r\n    top: 24px;\r\n    right: 20px;\r\n\r\n    button.mat-mdc-button {\r\n      min-width: 36px;\r\n      width: 36px;\r\n      padding: 0;\r\n      margin: 0 4px;\r\n      background: rgba(255, 252, 252, 0.6);\r\n      transition: 0.2s;\r\n      color: rgba(0, 0, 0, 0.87);\r\n\r\n      &:disabled {\r\n        color: rgba(0, 0, 0, 0.26);\r\n      }\r\n\r\n      &:hover:enabled {\r\n        background: rgba(255, 252, 252, 1);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.small-carousel {\r\n  .swiper-slide {\r\n    img {\r\n      display: block;\r\n      opacity: 0.3;\r\n    }\r\n\r\n    &.active-thumb {\r\n      img {\r\n        border-width: 3px;\r\n        border-style: solid;\r\n        box-sizing: border-box;\r\n        opacity: 1;\r\n      }\r\n    }\r\n\r\n    .swiper-lazy-preloader {\r\n      margin-top: 10px;\r\n    }\r\n  }\r\n}\r\n\r\n.widget {\r\n  margin-bottom: 40px;\r\n\r\n  .widget-title {\r\n    margin: 0 -16px 16px;\r\n    padding: 8px 16px;\r\n    text-transform: uppercase;\r\n    font-weight: 400;\r\n  }\r\n\r\n  &:first-child {\r\n    .widget-title {\r\n      margin: -16px -16px 16px;\r\n      padding: 8px 16px;\r\n      text-transform: uppercase;\r\n      font-weight: 400;\r\n    }\r\n  }\r\n}\r\n\r\n.c-opidHus {\r\n  width: auto;\r\n  padding: 0;\r\n  margin: 0 4px;\r\n  background: rgba(255, 252, 252, 0.8);\r\n  transition: 0.2s;\r\n  color: rgba(0, 0, 0, 0.87);\r\n  position: absolute;\r\n  z-index: 10;\r\n  padding: 2px 5px;\r\n  max-width: 70vw;\r\n  /* Setur hámarksbreiddina í 70% af skjávíddinni */\r\n  word-wrap: break-word;\r\n  /* Tryggir að textinn fari í næstu línu þegar hámarksbreiddin er náð */\r\n  white-space: normal;\r\n  /* Leyfir textanum að brjótast í nýjar línur */\r\n}\r\n\r\n.c-distances-container {\r\n  margin: 5px 0px 5px 0px !important;\r\n}\r\n\r\n.c-distances .c-pic {\r\n  width: 50%;\r\n  height: 70px;\r\n  float: left;\r\n  text-align: center;\r\n}\r\n\r\n.c-distances .c-pic img {\r\n  height: 50px !important;\r\n  float: right;\r\n  margin-top: 10px !important;\r\n  margin-right: 10px;\r\n}\r\n\r\n.c-distances .c-text {\r\n  width: 50%;\r\n  float: left;\r\n}\r\n\r\n.c-distances .c-text .c-head {\r\n  margin-top: 10px !important;\r\n  font-size: 16px;\r\n  color: $primary-500;\r\n  font-weight: 400;\r\n  margin-bottom: 0px !important;\r\n}\r\n\r\n.c-distances .c-text .c-text-dist {\r\n  font-size: 15px;\r\n  margin-bottom: 0px !important;\r\n}\r\n\r\n.box.c-distances {\r\n  width: 33% !important;\r\n}\r\n\r\n#thrsix-big {\r\n  position: absolute;\r\n  top: 84px;\r\n  right: 114px;\r\n  z-index: 3;\r\n  background: $primary-500;\r\n  color: white;\r\n  padding: 7px 14px;\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n  opacity: 0.7;\r\n  transition: 0.5s;\r\n  height: 32px;\r\n  width: 55px;\r\n  border-right: 1px solid #ffffff85;\r\n}\r\n\r\n#fjarlaegd-i-thonustu {\r\n  margin-bottom: 0px !important;\r\n  border-bottom: none !important;\r\n  padding-bottom: 5px !important;\r\n}\r\n\r\n.no-spinner {\r\n  -moz-appearance: textfield;\r\n  /* Hide the spinner controls in Firefox */\r\n}\r\n\r\n/* Hide the spinner controls in Chrome, Safari, Edge, Opera */\r\n.no-spinner::-webkit-outer-spin-button,\r\n.no-spinner::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n.button-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n\r\n  .button {\r\n    width: 48%;\r\n    margin-bottom: 10px;\r\n\r\n    &.left-button {\r\n      // Sérstakar stílar fyrir vinstri takkann\r\n    }\r\n\r\n    &.right-button {\r\n      // Sérstakar stílar fyrir hægri takkann\r\n    }\r\n  }\r\n\r\n  @media (max-width: 1000px) {\r\n    display: flow-root !important;\r\n\r\n    .button {\r\n      width: 100% !important;\r\n      margin-bottom: 10px !important;\r\n    }\r\n  }\r\n}\r\n\r\n.details-fasteign {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.item-fasteign {\r\n  text-align: left;\r\n  flex: 0 0 100%;\r\n  margin-bottom: 5px !important;\r\n  padding-left: 18px !important;\r\n}\r\n\r\n.kaupsamningar-saga .item-fasteign {\r\n  margin-bottom: 8px !important;\r\n}\r\n\r\n@media (min-width: 600px) {\r\n  .item-fasteign {\r\n    border-left: 1px solid #f0f0f0;\r\n    flex: 0 0 50%;\r\n    margin-bottom: 2px !important;\r\n  }\r\n\r\n  .item-fasteign-full {\r\n    flex: 0 0 100% !important;\r\n  }\r\n\r\n  .kaupsamningar-saga .item-fasteign {\r\n    margin-bottom: 5px !important;\r\n  }\r\n}\r\n\r\n.fasteignasala-mynd {\r\n  float: left;\r\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;\r\n  max-height: 200px;\r\n  width: 100%;\r\n  -o-object-fit: contain;\r\n  object-fit: contain;\r\n}\r\n\r\n.swiper-img {\r\n  max-height: 150px !important;\r\n}\r\n\r\n// .theme-container {\r\n//   max-width: 1200px !important;\r\n// }\r\n\r\niframe {\r\n  border: none !important;\r\n  border-radius: 0% !important;\r\n}\r\n\r\n.grunnupplysingar {\r\n  margin-top: 10px;\r\n  border: 1px solid #f0f0f0;\r\n  padding-top: 12px !important;\r\n  padding-bottom: 10px !important;\r\n}\r\n\r\n.fetch-documents {\r\n  border: 1px solid #f0f0f0;\r\n  padding: 10px;\r\n}\r\n\r\n.map-container {\r\n  position: relative;\r\n}\r\n\r\n.custom-info-box {\r\n  position: fixed;\r\n  background: white;\r\n  border: 1px solid #ccc;\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\r\n  z-index: 1000;\r\n  min-width: 200px;\r\n  max-width: 300px;\r\n}\r\n\r\n.info-box-content {\r\n  font-size: 14px;\r\n  color: #333;\r\n}\r\n\r\n.info-box-image {\r\n  display: block;\r\n  max-width: 100%;\r\n  height: auto;\r\n  max-height: 200px;\r\n  /* Stilltu eftir hentugleika */\r\n  object-fit: contain;\r\n  margin: 0 auto 10px;\r\n}\r\n\r\n.info-box-button {\r\n  display: block;\r\n  width: 100%;\r\n  background: $primary-500;\r\n  color: white;\r\n  padding: 8px;\r\n  text-align: center;\r\n  border-radius: 5px;\r\n  margin-top: 10px;\r\n  cursor: pointer;\r\n  border: none;\r\n}\r\n\r\n.info-box-close {\r\n  display: block;\r\n  width: 100%;\r\n  background: #ccc;\r\n  padding: 8px;\r\n  text-align: center;\r\n  border-radius: 5px;\r\n  margin-top: 5px;\r\n  cursor: pointer;\r\n  border: none;\r\n}\r\n\r\ninput::-webkit-outer-spin-button,\r\ninput::-webkit-inner-spin-button {\r\n  /* display: none; <- Crashes Chrome on hover */\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n  /* <-- Apparently some margin are still there even though it's hidden */\r\n}\r\n\r\ninput[type=\"number\"] {\r\n  -moz-appearance: textfield;\r\n  /* Firefox */\r\n}\r\n\r\n.c-link {\r\n  color: $main-text-color !important;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  .box.c-distances {\r\n    width: 50% !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 800px) {\r\n  .box.c-distances {\r\n    width: 100% !important;\r\n  }\r\n\r\n  .custom-info-box {\r\n    position: absolute !important;\r\n  }\r\n}\r\n\r\n.custom-info-box.hidden {\r\n  display: none;\r\n}\r\n\r\n.ad-2-mobile {\r\n  display: block;\r\n  height: 195px;\r\n\r\n  // Frá ca. 640px (sm breakpoint) fer hún að hækka\r\n  @media (min-width: 500px) {\r\n    height: 245px;\r\n  }\r\n\r\n  // Frá ca. 640px (sm breakpoint) fer hún að hækka\r\n  @media (min-width: 600px) {\r\n    height: 300px;\r\n  }\r\n\r\n  // Eitthvað á milli (t.d. 700px)\r\n  @media (min-width: 700px) {\r\n    height: 390px;\r\n  }\r\n\r\n  // Eitthvað á milli (t.d. 700px)\r\n  @media (min-width: 800px) {\r\n    height: 450px;\r\n  }\r\n\r\n  // Upp að md (ca. 768px), sem er síðasti breakpoint áður en hún hverfur\r\n  @media (min-width: 960px) {\r\n    display: none;\r\n  }\r\n}\r\n\r\n// MBL styles\r\n\r\n.mblInject .primary-color {\r\n  color: $main-text-color !important;\r\n\r\n  p,\r\n  h1,\r\n  h2,\r\n  h3,\r\n  h4,\r\n  h5,\r\n  h6,\r\n  span,\r\n  li,\r\n  a,\r\n  label,\r\n  strong,\r\n  em,\r\n  small,\r\n  i,\r\n  i::before {\r\n    color: $main-text-color !important;\r\n  }\r\n}\r\n\r\n.color-mbl-green::before {\r\n  color: $primary-mbl-green !important;\r\n}\r\n\r\n.block-display {\r\n  display: block !important;\r\n}\r\n\r\n// Inputs colors\r\n::ng-deep .mat-mdc-form-field.mbl-input {\r\n  --mdc-outlined-text-field-outline-color: #a0a0a0 !important;\r\n\r\n  .mdc-notched-outline {\r\n    border-color: #a0a0a0 !important;\r\n  }\r\n\r\n  &.mat-focused {\r\n    --mdc-outlined-text-field-focus-outline-color: #008800 !important;\r\n\r\n    .mdc-notched-outline {\r\n      border-color: #008800 !important;\r\n    }\r\n  }\r\n\r\n  mat-label {\r\n    color: rgba(0, 0, 0, 0.87) !important;\r\n  }\r\n}\r\n\r\n.mdc-list-item__primary-text {\r\n  color: rgba(0, 0, 0, 0.87) !important;\r\n}\r\n\r\n.custom-tooltip {\r\n  padding: 8px !important;\r\n}\r\n\r\n/* Þegar elementið er í fullscreen þarf það að fylla skjáinn */\r\n#leafletMap:fullscreen,\r\n#leafletMap:-webkit-full-screen {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: block;\r\n}","// ------------ Fonts -------------\r\n$main-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n\r\n// ------------ MAIN COLORS -------------\r\n$primary-light-blue: #4695e7;\r\n$primary-lighter-blue: #5faffb;\r\n$primary-blue: #253a85;\r\n$primary-dark-blue: #082a54;\r\n$primary-pink: #e06902;\r\n$primary-pink-500: #e06902;\r\n\r\n$primary-200: #082a54;\r\n$primary-500: #253a85;\r\n$primary-800: #082a54;\r\n\r\n// Content\r\n$main-content-color: #f7f7f7;\r\n$light-weight-content: #f9fafd;\r\n$main-content-background-color: #fafafa;\r\n$main-text-color: rgba(0, 0, 0, 0.87);\r\n$loading-background: rgb(35 54 87);\r\n\r\n$gray-white: #d1ecf1;\r\n$white: rgb(255, 255, 255);\r\n$white-weak: rgb(255, 255, 255, 0.5);\r\n$white-hover: rgb(212, 212, 212);\r\n$darker-white: #fefefe;\r\n$mat-title-color: #1e293b;\r\n\r\n// GrayWhite\r\n$gray-white-color: #e9e9e9;\r\n$gray-white-color-hover: #f6f6f6;\r\n\r\n$background-color-soft-blue: rgb(35 54 87);\r\n\r\n// MBL colors\r\n$primary-mbl-green: #008800;\r\n\r\n// --------------------------------\r\n\r\n// ------------- ALERT-------------\r\n// Alert Dark Background\r\n$alert-b-color: #323130;\r\n\r\n// Alert color\r\n$alert-color: rgb(111, 2, 1);\r\n$alert-text-color: rgb(255, 255, 255);\r\n\r\n// Notification color\r\n$notification-color: #fa3e3e;\r\n\r\n// Alert yellow color\r\n$alert-yellow-color: #f6be00;\r\n$alert-yellow-color-light: rgb(253, 244, 164);\r\n$alert-b-color: #323130;\r\n\r\n$text-border: 1px solid rgba(0, 0, 0, 0.1);\r\n$box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);\r\n\r\n$gray-scale-color: rgb(233, 235, 238);\r\n$gray-logo-color-light: rgb(173, 173, 173);\r\n$gray-logo-color: rgb(132, 132, 132);\r\n$success-color: rgb(83, 189, 120);\r\n\r\n$confirm-color-m: #53bd78;\r\n$alert-color-m: rgba(239, 191, 0, 1);\r\n$alert-safe: #eed202;\r\n$confirm-color-m-weak: rgba(81, 189, 119, 0.129);\r\n$alert-color-m-weak: rgba(239, 191, 0, 0.11);\r\n\r\n$panel-color: #323130;\r\n$lighter-dark: #3c4146;\r\n\r\n$basic-gray: #f1f5f9;\r\n$basic-fuse-gray: #64748b;\r\n\r\n$form-color: rgb(148, 168, 184);\r\n\r\n// --------------------------------"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
